<script>
export default {
  name: 'RealEstateTabs',
  computed: {
    isAgentsTab() {
      return this.$route.name === 'real_estate_agents';
    },
    isCalendarTab() {
      return this.$route.name === 'real_estate_calendar';
    },
  },
};
</script>

<template>
  <nav class="flex gap-4 border-b border-slate-200 dark:border-slate-700">
    <router-link
      :to="{
        name: 'real_estate',
        params: { accountId: $route.params.accountId },
      }"
      class="pb-2 text-sm font-medium border-b-2"
      :class="
        !isAgentsTab && !isCalendarTab
          ? 'border-woot-500 text-woot-600 dark:text-woot-400'
          : 'border-transparent text-slate-500 dark:text-slate-400'
      "
    >
      {{ $t('REAL_ESTATE.TABS.PROJECTS') }}
    </router-link>
    <router-link
      :to="{
        name: 'real_estate_agents',
        params: { accountId: $route.params.accountId },
      }"
      class="pb-2 text-sm font-medium border-b-2"
      :class="
        isAgentsTab
          ? 'border-woot-500 text-woot-600 dark:text-woot-400'
          : 'border-transparent text-slate-500 dark:text-slate-400'
      "
    >
      {{ $t('REAL_ESTATE.TABS.AGENTS') }}
    </router-link>
    <router-link
      :to="{
        name: 'real_estate_calendar',
        params: { accountId: $route.params.accountId },
      }"
      class="pb-2 text-sm font-medium border-b-2"
      :class="
        isCalendarTab
          ? 'border-woot-500 text-woot-600 dark:text-woot-400'
          : 'border-transparent text-slate-500 dark:text-slate-400'
      "
    >
      {{ $t('REAL_ESTATE.TABS.CALENDAR') }}
    </router-link>
  </nav>
</template>
